import React, { useState, useEffect } from 'react';
import { Country } from '../types';

const Filter = () => {
    const [countries, setCountries ] = useState<Country[]>([]);
    const [search, setSearch] = useState("");
    const [filteredCountries , setFilteredCountries] = useState<Country[]>([]);
    
    const fetchCountryData = async () => {
        const response = await fetch("https://restcountries-v2.herokuapp.com/all")
        const countries = await response.json()
        setCountries(countries);
       // console.log(countries);
    };

    useEffect(() => {
    fetchCountryData()
   
}, []);

    useEffect(() => {
        setFilteredCountries(
            countries.filter(country => {
                return country.name.toLowerCase().includes(search.toLowerCase())
            })
        )
    }, [search, countries]);
    
    return(
        <>
         <form className="form">
            <input type="search" name="search" placeholder="Search for any country..." 
            onChange={(e) => setSearch(e.target.value)}/>
        </form>
        <table>
           {filteredCountries.map((country) => {
           const {numericCode, name, population, languages, region, flag} = country
           return ( 
                    <tbody key={numericCode}>
                    <tr>
                    <td className="flag"><img src={flag} alt={name} /></td>
                    <td>{name}</td>
                    <td>{population}</td>
                    <td>{languages.map((l) => (<li>{l.name}</li>))}</td>
                    <td>{region}</td>
                    </tr>
                    </tbody>
                )
            })}
            </table>
        </>
        );
}

export default Filter;
